"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreadSchema = void 0;
const yup = __importStar(require("yup"));
const ta = __importStar(require("../attributes/threadAttributes"));
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
exports.ThreadSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes.Thread),
    sellingUnit: utils_1.reqSelectOneSchema(Object.values(ta.SellingUnit)),
    spoolSize: utils_1.reqSelectOneSchema(Object.values(ta.SpoolSize)),
    indusWeight: utils_1.reqSelectOneSchema(Object.values(ta.IndustrialWeight)),
    bulky: yup.boolean(),
    threadOnSpool: utils_1.reqSelectOneSchema(Object.values(ta.ThreadOnSpool)),
    colour: shared.colourSchema,
    colourTone: shared.colourToneSchema,
    threadType: shared.titleSetLargeSchema.required(),
    material: shared.titleSetSmallSchema.required(),
    uses: shared.usesSchema,
    imperfections: shared.imperfectionsSchema.transform((val) => {
        if (val[0] instanceof Array)
            return val[0];
        return val;
    }),
    quantity: shared.quantitySchema.required(),
    packSize: shared.packSizeSchema.max(20),
    brand: shared.brandSchema,
    price: shared.priceSchema
})
    .when('$product.sellingUnit', (sellingUnit, schema) => {
    switch (sellingUnit) {
        case ta.SellingUnit.Individual:
            return schema.omit(['packSize']);
        default:
            return schema;
    }
})
    .when('$product.spoolSize', (spoolSize, schema) => {
    if (spoolSize !== ta.SpoolSize.Industrial) {
        return schema.omit(['indusWeight', 'bulky']);
    }
    return schema;
})
    .test('Context Check', "Product Validator needs product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=threadSchema.js.map